type PostHogSessionReplayClient = {
  sessionRecordingStarted: () => boolean;
  get_session_replay_url: (options?: {
    withTimestamp?: boolean;
    timestampLookBack?: number;
  }) => string | undefined;
};

type SentryEventWithExtra = {
  extra?: Record<string, unknown>;
};

export type { SentryEventWithExtra };

export const appendPostHogSessionReplayToSentryEvent = (
  event: SentryEventWithExtra,
  posthogClient: PostHogSessionReplayClient,
): SentryEventWithExtra => {
  if (!posthogClient.sessionRecordingStarted()) {
    return event;
  }

  const replayUrl = posthogClient.get_session_replay_url({ withTimestamp: true });
  if (!replayUrl) {
    return event;
  }

  if (!event.extra) {
    event.extra = { PostHog: replayUrl };
  } else {
    event.extra.PostHog = replayUrl;
  }

  return event;
};
